import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';

const FailedIcon = (): JSX.Element => {
  return (
    <div style={{ color: '#ff6565' }}>
      <CancelIcon />
    </div>
  );
};

export default FailedIcon;
